import App from './App.vue';

export default {
  path: '/CDS_VF_ChatList',
  name: 'CDS_VF_ChatList',
  component: App,
  meta: {
    pageProperty: {
      title: 'チャット履歴',
      controller: 'CDS_CTR_ChatList',
    },
  },
};
